import { useQuery } from "@tanstack/react-query";

import { getStorefrontCollection } from "../services/frontend/storefront-apis";

/**
 * Resolve /collections/<handle> on the backend: the collection, plus `redirect` (its canonical
 * handle) when the URL is an old one. Not limited to the collections list, so any active
 * collection resolves. A 404 is final, so it is not retried.
 */
const useStorefrontCollection = (handle) =>
  useQuery({
    queryKey: ["storefrontCollection", handle],
    queryFn: () => getStorefrontCollection(handle),
    enabled: Boolean(handle) && handle !== "all",
    retry: (failureCount, error) => error?.code !== "COLLECTION_NOT_FOUND" && failureCount < 2,
    cacheTime: 30 * 1000,
    staleTime: 30 * 1000,
  });

export default useStorefrontCollection;
